import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import axios from "axios";
import FileDownload from "js-file-download";
import { errorNotification } from "../../utils/notifications";
import CoordinadorAdministrativoCalificacion from "../../types/CoordinadorAdministrativoCalificacion";

const COMISION_COORDINADOR_ADMINISTRATIVO_BASE_URL =
  "/api/comisiones-coordinador-administrativo";

export const procesarExcel = (
  formData: FormData,
  periodo: string,
  confirmacion: boolean
): IAction => {
  return {
    type: actionTypes.POST_COMISION_COORDINADOR_ADMINISTRATIVO_PROCESAR_EXCEL,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_COORDINADOR_ADMINISTRATIVO_BASE_URL}/procesar-excel`,
      formData,
      {
        withCredentials: true,
        params: { periodo, confirmacion }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getComisionesPorPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_COORDINADOR_ADMINISTRATIVO_BY_PERIODO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_COORDINADOR_ADMINISTRATIVO_BASE_URL}/comisiones`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const clearComisiones = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_COORDINADOR_ADMINISTRATIVO,
    payload: true
  };
};

export const getComisionesByPeriodoReporte = (periodo: any, callback: any) => {
  return axios
    .get(
      `${constants.BASE_URL}${COMISION_COORDINADOR_ADMINISTRATIVO_BASE_URL}/comisiones/descargar`,
      {
        withCredentials: true,
        responseType: "blob",
        params: { periodo }
      }
    )
    .then(({ data }) => {
      FileDownload(data, `Compensaciones-${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const postCalificacionesReporte = (
  calificaciones: CoordinadorAdministrativoCalificacion[],
  periodoDesc: any,
  callback: any
) => {
  return axios
    .post(
      `${constants.BASE_URL}${COMISION_COORDINADOR_ADMINISTRATIVO_BASE_URL}/calificaciones/descargar`,
      calificaciones,
      {
        withCredentials: true,
        responseType: "blob"
      }
    )
    .then(({ data }) => {
      FileDownload(data, `Resultados de Compensaciones - ${periodoDesc}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};
